import { Component, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StepperService } from 'src/app/services/stepperService/stepper.service';
import { ThemesService } from 'src/app/services/commonService/themes.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { CorporateInfoComponent } from '../../components/corporate-info/corporate-info.component';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { Subject, takeUntil } from 'rxjs';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BusinessOwnerInfoComponent } from '../../components/business-owner-info/business-owner-info.component';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['../signup.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, CorporateInfoComponent, BusinessOwnerInfoComponent]
})
export class SignupComponent implements OnInit, OnDestroy {
  @ViewChild(CorporateInfoComponent)
  corporateInfoComponent!: CorporateInfoComponent;
  content: any;
  activeStep: string = 'corporate';
  showCorporateInfo = true;
  showbusinessOwnerInfo = false;
  corporateInfo: any = null;
  EditLink: boolean = false;
  showbusinessOwnerform = false;
  CorporateHeading = true;
  AgreeDataUse = false;
  show: boolean = true;
  EditLinkOwner: boolean = false;
  Isprocess: string = 'FIRST';
  corporateInfoVisisble: boolean = true;
  Shub = false; // Additional state
  showForm = true; // Control form visibility
  private destroy$ = new Subject<void>();

  constructor(
    private _stepperService: StepperService,
    private _ThemeService: ThemesService,
    private regUtilityService: RegistationUtilitiesService,
    private router: Router,
    private _DataLayerService: DataLayerService,
    private contenService: SignUpContentServiceService
  ) {}
  ngOnInit() {
    this._ThemeService.clearThemes();
    // this._DataLayerService.onLanding_signup_form(); // GTM use
    this.contenService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
      });
  }
  navigateToLogin() {
    this.router.navigate(['/login']);
    this._DataLayerService.signup_login_onclick(); //GTM use
  }
  showCorporateInfoForm() {
    this._stepperService.RegstrationStepper('Corporate');
    this.showCorporateInfo = true; // Set flag to true to show the form
    this.Shub = false; // Manipulate Shub state as needed
    this.showForm = false; // Hide the form if needed
    this.EditLink = false;
    this.show = true;
    this.corporateInfoComponent.Shub = false;
    this.corporateInfoComponent.showForm = true;
    this.showbusinessOwnerInfo = false;
  }
  handleFormSubmit(formData: any) {
    //on first form save
    if (this.Isprocess === 'FIRST') {
      this.corporateInfo = formData;
      this.Isprocess = 'SECOND';
      //  this.show = !this.show;
      this.EditLink = false;
      this.showForm = false;
      this.EditLinkOwner = false;
      this.showCorporateInfo = false;
      this.showbusinessOwnerInfo = true;
      this.showbusinessOwnerform = true;
      this.CorporateHeading = false;
      this.regUtilityService.setStep('business');
      this.AgreeDataUse = false;
      sessionStorage.setItem('previousPage','Company Details Page');
      this._DataLayerService.registrationPageLanding('Travel Administrator Details Page');
      this._stepperService.RegstrationStepper('Travel Administrator');
    } else {
      // Corporate edit/save ke baad latest corporate data update hona chahiye,
      // taaki business-owner-info me [corporateInfo] ke through validations sahi rahein.
      this.corporateInfo = formData;
      this._DataLayerService.registrationPageLanding('Review Details Page');
      this.showForm = false;
      // this.show = !this.show; Review
      this.EditLink = true;
      this.CorporateHeading = true;
      this.showCorporateInfo = true;
      this.showbusinessOwnerInfo = true;
      this.showbusinessOwnerform = false;
      this.EditLinkOwner = true;
      this.regUtilityService.setStep('business');
      this._stepperService.RegstrationStepper('Review');
    }
  }
  handleFormSAve(formData: any) {
    // this.corporateInfo = formData;                 second time when save is clicked
    this.showForm = false;
    // this.show = !this.show;
    this.EditLink = true;
    this.CorporateHeading = true;
    this.showCorporateInfo = true;
    this.showbusinessOwnerInfo = true;
    this.showbusinessOwnerform = false;
    this.EditLinkOwner = true;
    this.regUtilityService.setStep('business');
  }
  editClicked(formData: any) {
    // show corporate form on corporate edit click
    //  this.corporateInfo = formData;
    //  this.show = !this.show;
    this.EditLink = false;
    this.showForm = true;
    this.showCorporateInfo = true;
    this.showbusinessOwnerInfo = false;
    //   this.showbusinessOwnerform=false;
    this.CorporateHeading = false;
    this.regUtilityService.setStep('business');
  }
  EditBusinessowner(formData: any) {
    // show businessowner form on businessowner edit click
    //   this.corporateInfo = formData;
    //  this.show = !this.show;
    this.EditLink = false;
    this.showForm = false;
    this.EditLinkOwner = false;
    this.showCorporateInfo = false;
    this.showbusinessOwnerInfo = true;
    this.showbusinessOwnerform = true;
    this.CorporateHeading = false;
    this.regUtilityService.setStep('business');
  }
  handleBusinessOwnerInfoSubmit(businessOwnerInfo: any) {}
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
